import { Href } from 'expo-router';

export const concatPath = (pathKeys: string[], order: number = 1) : Href | string => {
  let prefix = '';

  switch(order) {
  case 0:
    prefix = '.';
    break;
  case 1:
    prefix = '..';
    break;
  case 2:
    prefix = '../..';
    break;
  case 3:
    prefix = '../../..';
    break;
  default: // max order: 4
    prefix = '../../../..';
    break;
  }
  const combinedPath = pathKeys.reduce((acc, key) => {
    return `${acc}/${key}`;
  }, '');
  // order -1 means ABSOLUTE, so keep the leading slash. This used to `.substring(1)`
  // it away, which made every "absolute" href actually relative -- and that has already
  // cost two user-visible bugs: a logout landing on /(private)/(public)/(Tabs)/login,
  // and a white screen when the slash-less form reached <Redirect>. Fixing it here
  // covers all ~54 order -1 call sites at once, rather than each remembering to prefix
  // a '/' by hand.
  if(order === -1) return combinedPath as Href | string;
  return prefix+combinedPath; // relative path
};